(function (app, core) {
    'use strict';

    app.MainNav = function ( container ) {
        const _self = this;

        if ( window.matchMedia( "( max-width: 640px )" ).matches) {
            const eventTabs = container.querySelectorAll( '.js-link' );        
            eventTabs.forEach( tab => {
                if ( core.style.hasClass( tab, 'isActive' ) ) {
                    const container = tab.parentElement.parentElement;
                    let offsetLeft = tab.offsetLeft;
                    container.scrollTo( offsetLeft, 0 );
                }
            } );
        }
    };

    let widgets = document.querySelectorAll('[data-widget="fixtures-main-nav"]');

    Array.prototype.forEach.call( widgets, function ( widget ) {
        new app.MainNav( widget );
    });
})( PULSE.app, PULSE.core );